import { render, staticRenderFns } from "./PendingProjectSettingsForm.vue?vue&type=template&id=cf3ca876"
import script from "./PendingProjectSettingsForm.vue?vue&type=script&lang=ts"
export * from "./PendingProjectSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./PendingProjectSettingsForm.vue?vue&type=style&index=0&id=cf3ca876&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports